import T from "../../theme";
import { Icon } from "../ui/Icon";
import { Avatar } from "../ui/Avatar";
import { NavButton, UserFooter, logoEscuro, logoBranco } from "./navShared";
import { SETTINGS_ENABLED } from "../../constants";

export const Sidebar = ({ user, page, setPage, tickets, onLogout, onEditProfile, dark, onToggleDark, activeCondo, onChangeCondo, condoCount, onReturnToCockpit, isDemo = false }) => {
  const isAdmin = user.role === "admin";
  const demoLocked = isDemo ? new Set(["tickets", "docs", "assistente", "users"]) : new Set();

  const nav = [
    { id: "home",       label: "Dashboard",    icon: "home" },
    { id: "tickets",    label: "Ocorrências",  icon: "tickets" },
    { id: "docs",       label: "Documentos",   icon: "docs" },
    { id: "suppliers",      label: "Fornecedores",  icon: "suppliers" },
    { id: "notifications", label: "Notificações", icon: "bell" },
    { id: "assistente",    label: "Assistente",    icon: "chat" },
    ...(isAdmin ? [{ id: "budget",   label: "Orçamento",    icon: "wallet"   }] : []),
    { id: "quotas", label: "Quotas", icon: "coins" },
    ...(isAdmin ? [{ id: "users",    label: "Utilizadores", icon: "users"    }] : []),
    ...(isAdmin ? [{ id: "settings", label: "Definições",   icon: "settings" }] : []),
  ];

  const openCount = tickets.filter(t => t.status === "Aberto").length;

  return (
    <div style={{ width: 236, background: T.sidebar, borderRight: `1px solid ${T.border}`, display: "flex", flexDirection: "column", flexShrink: 0 }}>

      {/* Logo */}
      <div style={{ padding: "20px 18px 16px", borderBottom: `1px solid ${T.border}` }}>
        <img src={dark ? logoEscuro : logoBranco} alt="VillaGest" style={{ height: 28, width: "auto", display: "block" }} />
      </div>

      {/* Back to Cockpit */}
      {onReturnToCockpit && (
        <div style={{ padding: "10px 14px", borderBottom: `1px solid ${T.border}` }}>
          <button
            onClick={onReturnToCockpit}
            style={{
              width: "100%", display: "flex", alignItems: "center", gap: 8,
              padding: "8px 10px", borderRadius: 8,
              background: T.warningLight, border: `1px solid ${T.warning}`,
              cursor: "pointer", fontFamily: "inherit", transition: "all 0.15s",
            }}
            onMouseEnter={e => { e.currentTarget.style.opacity = "0.8"; }}
            onMouseLeave={e => { e.currentTarget.style.opacity = "1"; }}
          >
            <Icon name="back" size={14} color={T.warning} />
            <span style={{ fontSize: 12, fontWeight: 600, color: T.warning }}>Voltar ao Cockpit</span>
          </button>
        </div>
      )}

      {/* Condo selector */}
      {activeCondo && condoCount > 1 && (
        <div style={{ padding: "10px 14px", borderBottom: `1px solid ${T.border}` }}>
          <button
            onClick={condoCount > 1 ? onChangeCondo : undefined}
            title={condoCount > 1 ? "Mudar de condomínio" : activeCondo.name}
            style={{
              width: "100%", display: "flex", alignItems: "center", gap: 8,
              padding: "8px 10px", borderRadius: 8, background: T.bg,
              border: `1px solid ${T.border}`, cursor: condoCount > 1 ? "pointer" : "default",
              transition: "all 0.15s", fontFamily: "inherit",
            }}
            onMouseEnter={e => { if (condoCount > 1) e.currentTarget.style.borderColor = T.primary; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = T.border; }}
          >
            <Icon name="building" size={14} color={T.primary} />
            <span style={{
              flex: 1, fontSize: 12, fontWeight: 600, color: T.text,
              overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", textAlign: "left",
            }}>
              {activeCondo.name}
            </span>
            {condoCount > 1 && <Icon name="swap" size={12} color={T.textMuted} />}
          </button>
        </div>
      )}

      {/* Nav */}
      <nav style={{ flex: 1, padding: "10px 10px", overflowY: "auto" }}>
        {nav.map(item => {
          const locked = demoLocked.has(item.id);
          const soon = item.id === "settings" && !SETTINGS_ENABLED;
          return (
            <NavButton
              key={item.id}
              item={item}
              active={page === item.id}
              onClick={() => setPage(item.id)}
              badge={item.id === "tickets" && openCount > 0}
              suffix={soon ? <span style={{ fontSize: 10, fontWeight: 600, opacity: 0.7 }}>Brevemente</span> : locked ? <span style={{ fontSize: 11, opacity: 0.5 }}>🔒</span> : null}
              dimmed={locked || soon}
            />
          );
        })}
      </nav>

      {/* User / Profile */}
      <div style={{ padding: "12px 14px", borderTop: `1px solid ${T.border}` }}>
        <div
          onClick={!isAdmin ? onEditProfile : undefined}
          title={!isAdmin ? "Editar perfil" : undefined}
          style={{
            display: "flex", alignItems: "center", gap: 9,
            padding: "6px 6px", borderRadius: 8,
            transition: "background 0.15s",
            margin: "-6px -6px 10px",
            cursor: isAdmin ? "default" : "pointer",
          }}
          onMouseEnter={e => { if (!isAdmin) e.currentTarget.style.background = T.bg; }}
          onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}
        >
          <div style={{ position: "relative", flexShrink: 0 }}>
            <Avatar user={user} size={34} />
            {!isAdmin && (
              <div style={{ position: "absolute", bottom: -1, right: -1, width: 14, height: 14, background: T.primary, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", border: "1.5px solid #fff" }}>
                <Icon name="edit" size={7} color="#fff" />
              </div>
            )}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <p style={{ fontSize: 13, fontWeight: 600, color: T.text, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{user.name}</p>
            <p style={{ fontSize: 11, color: T.textMuted, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{user.email}</p>
            {isAdmin && (
              <span style={{ display: "inline-block", maxWidth: "100%", fontSize: 11, fontWeight: 600, background: T.primaryLight, color: T.primary, borderRadius: 4, padding: "2px 7px", marginTop: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", boxSizing: "border-box" }}>
                Administrador/a
              </span>
            )}
          </div>
        </div>

        <UserFooter dark={dark} onToggleDark={onToggleDark} onLogout={onLogout} />
      </div>
    </div>
  );
};
